<!-- NAVBAR SUPERIOR -->
<nav class="navbar fixed-top">
  <div class="d-flex justify-content-between w-100 px-3">
    <div class="menu d-flex align-items-center">
      <div class="barra sidebar-toggle" (click)="onHamburgerClick($event)" [class.x]="isHamburgerActive">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <a class="navbar-brand ms-2">VibeTex</a>
    </div>


    <!-- Botão de menu e logo -->

    <div class="navbar-nav d-flex align-items-center">
      <div class="user-info-container text-end">
        <span class="nav-link nav-link-navbar text-white mb-0">
          <strong>{{ nomeUsuario || userName }}</strong> ({{ role }})
        </span>
        <span class="company-name">{{ nomeDaEmpresa || '' }}</span>
      </div>
      <button (click)="requestLogout()" class="btn-sair-navbar btn btn-outline-danger btn-sm ms-2">
        Sair
      </button>
    </div>
  </div>
</nav>

<!-- SIDEBAR LATERAL -->
<div class="sidebar" [class.closed]="isSidebarClosed">
  <div class="sidebar-content" #sidebarContent (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)"
    (mouseup)="onMouseUp()" (mouseleave)="onMouseLeave()">

    <!-- Navigation Items Container -->
    <div class="sidebar-nav-items">
      <!-- Dashboard Link -->
      <a class="nav-link text-white" routerLink="/admin/dashboard">
        <i class="fas fa-chart-line me-2"></i>
        Dashboard
      </a>

      <!-- MENU: Usuários -->
      <div class="nav-item custom-dropdown">
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdown1($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-users-cog"></i>
              <span>Ger. Usuários</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownOpen1"></i>
          </div>
        </button>

        <div class="dropdown-content" [class.show]="isDropdownOpen1">
          <a class="dropdown-item" routerLink="/admin/cadastrar-usuario" (click)="closeDropdowns()"
            *ngIf="role === 'SuperAdministrador'">
            <i class="fas fa-user-plus me-2"></i>
            <span>Cadastrar Usuário</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/usuarios" (click)="onNavLinkClick()">
            <i class="fas fa-users me-2"></i>
            <span>Consultar Usuários</span>
          </a>
        </div>
      </div>
      
      <!-- MENU: Consumidor -->
      <!-- <div class="nav-item custom-dropdown">
        <div class="sidebar-divider"></div>
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdown($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-user-circle"></i>
              <span>Ger. Consumidor</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownOpen"></i>
          </div>
        </button>

        <div class="dropdown-content" [class.show]="isDropdownOpen">

          <a class="dropdown-item" routerLink="/admin/cadastrar-consumidor" (click)="closeDropdowns()"
            *ngIf="role === 'SuperAdministrador'">
            <i class="fas fa-user-plus me-2"></i>
            <span>Cadastrar Consumidor</span>
          </a>

          <a class="dropdown-item" routerLink="/admin/consulta-consumidor" (click)="closeDropdowns()">
            <i class="fas fa-users me-2"></i>
            <span>Consultar Consumidor</span>
          </a>
        </div>
      </div> -->
      <div class="sidebar-divider"></div>

      <!-- MENU: Vistoria -->
      <div class="nav-item custom-dropdown">
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdownServicos($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-concierge-bell"></i>
              <span>Serviços</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownServicosOpen"></i>
          </div>
        </button>
        <div class="dropdown-content" [class.show]="isDropdownServicosOpen">
          <a class="dropdown-item" routerLink="/admin/servicos" (click)="onNavLinkClick()">
            <i class="fas fa-list me-2"></i>
            <span>Todos</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/ordem-servico" (click)="closeDropdowns()">
            <i class="fas fa-file-alt me-2"></i>
            <span>Vistorias</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-cadastro" (click)="closeDropdowns()">
            <i class="fas fa-user-plus me-2"></i>
            <span>Cadastro Válido</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-recadastro" (click)="closeDropdowns()">
            <i class="fas fa-user-edit me-2"></i>
            <span>Recadastro Válido</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-pendentes" (click)="closeDropdowns()">
            <i class="fas fa-check"></i>
            <span>Concluídas</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/analise" (click)="closeDropdowns()">
            <i class="fas fa-tasks me-2"></i>
            <span>Em Análise</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-negativa" (click)="closeDropdowns()">
            <i class="fas fa-user-plus me-2"></i>
            <span>Negativa</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-invalidos" (click)="closeDropdowns()">
            <i class="fas fa-ban me-2"></i>
            <span>Invalidas</span>
          </a>
        </div>
      </div>
      <div class="sidebar-divider"></div>

      <!-- MENU: Jornada -->
      <div class="nav-item custom-dropdown">
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdownJornada($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-route"></i>
              <span>Jornada</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownJornadaOpen"></i>
          </div>
        </button>
        <div class="dropdown-content" [class.show]="isDropdownJornadaOpen">
          <a class="dropdown-item" routerLink="/admin/roteiro-colaborador" (click)="closeDropdowns()">
            <i class="fas fa-route me-2"></i>
            <span>Roteiro</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/historico-expediente"
            *ngIf="role !== 'Visitante' && role !== 'Consumidor'">
            <i class="fas fa-clock me-2"></i>
            Controle de Ponto
          </a>
        </div>
      </div>
      <div class="sidebar-divider"></div>

      <!-- MENU: Clientes Bases -->
      <a class="nav-link text-white" routerLink="/admin/cliente-base" *ngIf="role == 'SuperAdministrador'">
        <i class="fas fa-building me-2"></i>
        Clientes Base
      </a>

      <!-- MENU: Relatório -->
      <a class="nav-link text-white" routerLink="/admin/financeiro" *ngIf="role == 'SuperAdministrador' || role == 'Supervisor'">
        <i class="fas fa-file-excel me-2"></i>
        Financeiro
      </a>

      <!-- MENU: Auditoria -->
      <a class="nav-link text-white" routerLink="/admin/auditoria" *ngIf="role !== 'Visitante' && role !== 'Supervisor'">
        <i class="fas fa-clipboard-list me-2"></i>
        Auditoria
      </a>

      <!-- MENU: Suporte -->
      <!-- <a class="nav-link text-white" [routerLink]="suporteLink" (click)="onNavLinkClick()">
        <i class="fas fa-headset me-2"></i>
        Suporte
      </a> -->

      <!-- Botão de logout (visível no mobile) -->
      <button (click)="requestLogout()" class="btn-sair-sidebar btn btn-outline-danger btn-sm ms-2">
        Sair
      </button>
    </div>

    <!-- FOOTER DO SIDEBAR -->
    <div class="sidebar-footer">
      <div class="sidebar-footer-content">
      </div>
    </div>
  </div>
</div>

<!-- Custom Logout Confirmation Dialog -->
<div class="logout-confirm-overlay" *ngIf="showLogoutConfirm">
  <div class="logout-confirm-dialog">
    <h5>Confirmação de Saída</h5>
    <p>Deseja realmente sair do sistema?</p>
    <div class="logout-confirm-actions">
      <button class="btn btn-secondary btn-sm" (click)="cancelLogout()">Cancelar</button>
      <button class="btn btn-danger btn-sm" (click)="confirmLogout()">Sair</button>
    </div>
  </div>
</div>

  <!-- Mobile overlay showing all sidebar links when hamburger clicked -->
<div class="mobile-menu-overlay" *ngIf="isMobile && isMobileMenuOpen" (click)="closeMobileMenu()">
  <div class="mobile-menu" (click)="$event.stopPropagation()">
    <div class="sidebar-nav-items">
      <!-- Dashboard Link -->
      <a class="nav-link text-white" routerLink="/admin/dashboard" (click)="onNavLinkClick()">
        <i class="fas fa-chart-line me-2"></i>
        Dashboard
      </a>

      <!-- MENU: Usuários -->
      <div class="nav-item custom-dropdown">
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdown1($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-users-cog"></i>
              <span>Ger. Usuários</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownOpen1"></i>
          </div>
        </button>

        <div class="dropdown-content" [class.show]="isDropdownOpen1">
          <a class="dropdown-item" routerLink="/admin/cadastrar-usuario" (click)="closeDropdowns()"
            *ngIf="role === 'SuperAdministrador'">
            <i class="fas fa-user-plus me-2"></i>
            <span>Cadastrar Usuário</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/usuarios" (click)="onNavLinkClick()">
            <i class="fas fa-users me-2"></i>
            <span>Consultar Usuários</span>
          </a>
        </div>
      </div>
      
      <!-- MENU: Consumidor -->
      <!-- <div class="nav-item custom-dropdown">
        <div class="sidebar-divider"></div>
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdown($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-user-circle"></i>
              <span>Ger. Consumidor</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownOpen"></i>
          </div>
        </button>

        <div class="dropdown-content" [class.show]="isDropdownOpen">

          <a class="dropdown-item" routerLink="/admin/cadastrar-consumidor" (click)="closeDropdowns()"
            *ngIf="role === 'SuperAdministrador'">
            <i class="fas fa-user-plus me-2"></i>
            <span>Cadastrar Consumidor</span>
          </a>

          <a class="dropdown-item" routerLink="/admin/consulta-consumidor" (click)="closeDropdowns()">
            <i class="fas fa-users me-2"></i>
            <span>Consultar Consumidor</span>
          </a>
        </div>
      </div> -->
      <div class="sidebar-divider"></div>

      <!-- MENU: Vistoria -->
      <div class="nav-item custom-dropdown">
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdownServicos($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-concierge-bell"></i>
              <span>Serviços</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownServicosOpen"></i>
          </div>
        </button>
        <div class="dropdown-content" [class.show]="isDropdownServicosOpen">
          <a class="dropdown-item" routerLink="/admin/servicos" (click)="onNavLinkClick()">
            <i class="fas fa-list me-2"></i>
            <span>Todos</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/ordem-servico" (click)="closeDropdowns()">
            <i class="fas fa-file-alt me-2"></i>
            <span>Vistorias</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-cadastro" (click)="closeDropdowns()">
            <i class="fas fa-user-plus me-2"></i>
            <span>Cadastro Validado</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-recadastro" (click)="closeDropdowns()">
            <i class="fas fa-user-edit me-2"></i>
            <span>Recadastro</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-pendentes" (click)="closeDropdowns()">
            <i class="fas fa-check"></i>
            <span>Concluídas</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/analise" (click)="closeDropdowns()">
            <i class="fas fa-tasks me-2"></i>
            <span>Em Análise</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-negativa" (click)="closeDropdowns()">
            <i class="fas fa-user-plus me-2"></i>
            <span>Negativa</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/servicos-invalidos" (click)="closeDropdowns()">
            <i class="fas fa-ban me-2"></i>
            <span>Invalidas</span>
          </a>
        </div>
      </div>
      <div class="sidebar-divider"></div>

      <!-- MENU: Jornada -->
      <div class="nav-item custom-dropdown">
        <button class="nav-link w-100 text-start border-0" (click)="toggleDropdownJornada($event)">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fas fa-route"></i>
              <span>Jornada</span>
            </div>
            <i class="fas fa-chevron-down transition-icon" [class.rotate]="isDropdownJornadaOpen"></i>
          </div>
        </button>
        <div class="dropdown-content" [class.show]="isDropdownJornadaOpen">
          <a class="dropdown-item" routerLink="/admin/roteiro-colaborador" (click)="closeDropdowns()">
            <i class="fas fa-route me-2"></i>
            <span>Roteiro</span>
          </a>
          <a class="dropdown-item" routerLink="/admin/historico-expediente"
            *ngIf="role !== 'Visitante' && role !== 'Consumidor'">
            <i class="fas fa-clock me-2"></i>
            Controle de Ponto
          </a>
        </div>
      </div>
      <div class="sidebar-divider"></div>

      <!-- MENU: Relatório -->
      <a class="nav-link text-white" routerLink="/admin/relatorio" *ngIf="role == 'SuperAdministrador'"
        (click)="onNavLinkClick()">
        <i class="fas fa-file-excel me-2"></i>
        Relatório
      </a>

      <!-- MENU: Clientes Bases -->
      <a class="nav-link text-white" routerLink="/admin/cliente-base" *ngIf="role == 'SuperAdministrador'"
        (click)="onNavLinkClick()">
        <i class="fas fa-building me-2"></i>
        Clientes Base
      </a>

      <!-- MENU: Auditoria -->
      <a class="nav-link text-white" routerLink="/admin/auditoria" *ngIf="role !== 'Visitante'"
        (click)="onNavLinkClick()">
        <i class="fas fa-clipboard-list me-2"></i>
        Auditoria
      </a>

      <!-- MENU: Suporte -->
      <!-- <a class="nav-link text-white" [routerLink]="suporteLink" (click)="onNavLinkClick()">
        <i class="fas fa-headset me-2"></i>
        Suporte
      </a> -->
    </div>
  </div>
</div>